import React, { useEffect, useState } from 'react'
import { geocodeByPlaceId, getLatLng } from 'react-google-places-autocomplete'

import Filter from './filters/filter'
import { MDBContainer } from 'mdbreact'
import Views from './views/views'

let gmdv = require(`../../ghc_config`)

const Content = (props) => {
  let startpos = gmdv.USACenter
  let startradius = 150000

  if (props.overridestartpos != null) {
    startpos = props.overridestartpos
  }
  if (props.overrideradius != null) {
    startradius = props.overrideradius
  }

  const [locations, setLocations] = useState([])
  const [startPosition, setStartPosition] = useState(startpos)
  const [searchtype, setSearchtype] = useState(gmdv.searchtype)
  const [positionWindow, setPositionWindow] = useState(null)
  const [place, setPlace] = useState(null)
  const [stateCheck, setStateCheck] = useState(null)
  const [item, setItem] = useState(null)
  const [radius, setRadius] = useState(startradius)
  const [checkedItems, setCheckedItems] = useState([])
  const [placeholderAddress, setPlaceholderAddress] = useState(
    `Type an address`
  )
  const [placeholderCName, setPlaceholderCName] = useState(
    `Type an Center Name`
  )

  useEffect(() => {
    getGeoLocation()
  }, [])

  // worked Drupal Data
  useEffect(() => {
    let checkedItemsArray = gmdv.checkedItemsArrayFunc(checkedItems)

    //console.log(props.location)
    // findlocations service
    if (checkedItemsArray && checkedItemsArray.length == 0) {
      let serviceName = 'all'
      props.featuredServices.map((flserviceItem) => {
        let nameService = flserviceItem.node.name.split(' ')

        if (props.location.hash.includes(nameService[0].toLowerCase())) {
          serviceName = flserviceItem
        }
      })

      if (serviceName != 'all') {
        //console.log(`serviceName`, {[serviceName.node.id] : true })
        setCheckedItems({ [serviceName.node.id]: true })
        props.location.hash = ''
      }
    }

    let locationsArray = []
    let locations = props.allNodeCenter
    //console.log(gmdv.drupalData(startPosition, locations))

    locations.map((item) => {
      let services = item.node.relationships.field_services
      let servicesArray = gmdv.servicesArrayFunc(services)

      const checkFeaturedService = checkedItemsArray.every(function (item) {
        return servicesArray.indexOf(item) !== -1
      })
      //console.log(checkFeaturedService);
      if (checkFeaturedService) {
        locationsArray.push(item)
      }
    })

    if (props.overridedistancesort) {
      setLocations(gmdv.drupalDataNoSort(startPosition, locationsArray))
    } else {
      //  distance sorting
      setLocations(gmdv.drupalData(startPosition, locationsArray))
    }

    //console.log(locationsArray)
    //    setLocations(gmdv.drupalData(startPosition, locationsArray))
  }, [checkedItems])

  //  Current Position
  const getGeoLocation = () => {
    if (props.overridestartpos != null) {
      setStartPosition(startpos)
      return
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setStartPosition({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        })
      })
    } else {
      ;(error) => console.log(error)
      setStartPosition(gmdv.USACenter)
    }
  }

  //  Handlers
  const handleSearchtypeChange = (event) => {
    setSearchtype(event)
  }

  const handleRadiusChange = (event) => {
    setRadius(event)
    if (place) {
      handleACupdate(place)
    }
  }

  const handleCheckboxesChange = (e) => {
    const item = e.target.name
    const isChecked = e.target.checked
    let checkedItemsValue = { ...checkedItems, [item]: isChecked }
    if (isChecked === false) {
      delete checkedItemsValue[item]
    }
    setCheckedItems(checkedItemsValue)
  }

  const handleACupdate = (place) => {
    setPlaceholderAddress(`Type an address`)
    if (searchtype === 'location') {
      if (place) {
        if (place.types[0] === `administrative_area_level_1`) {
          setStateCheck(place.description)
        } else {
          setStateCheck(null)
        }
        setPlace(place)
        geocodeByPlaceId(place.place_id)
          .then((results) => {
            getLatLng(results[0])
              .then(({ lat, lng }) => {
                setPositionWindow(null)
                if (radius === 150000) {
                  setRadius(100)
                }
                setStartPosition({ lat: lat, lng: lng })
              })
              .catch((error) => {
                throw error
              })
          })
          .catch((error) => console.error(error))
      }
    }
  }

  const handleCentersNames = (cname) => {
    setPlaceholderCName(`Type an Center Name`)
    if (searchtype === 'namecenter') {
      if (
        startPosition.lat != Number(cname.node.field_latitude) ||
        startPosition.lng != Number(cname.node.field_longitude)
      ) {
        if (radius === 150000) {
          setRadius(25)
        }
        let geolocation = {
          lat: Number(cname.node.field_latitude),
          lng: Number(cname.node.field_longitude),
        }
        setStartPosition(geolocation)
        setPositionWindow(geolocation)
      }
    }
  }

  const handleToggleOpen = (itemClicked) => {
    let geolocation
    if (!itemClicked) {
      geolocation = gmdv.USACenter
    } else {
      geolocation = {
        lat: Number(itemClicked.node.field_latitude),
        lng: Number(itemClicked.node.field_longitude),
      }
      //window.location.hash = `ghccmap`;
      if (radius === 150000) {
        setRadius(25)
      }
    }

    if (positionWindow !== null) {
      if (item !== itemClicked) {
        //setStartPosition(geolocation)
        setPositionWindow(geolocation)
      } else {
        //setStartPosition(startPosition)
        setPositionWindow(null)
      }
    } else {
      //setStartPosition(geolocation)
      setPositionWindow(geolocation)
    }
    setItem(itemClicked)
  }

  const handleToggleCloseAll = () => {
    //setStartPosition(startPosition)
    setPositionWindow(null)
  }

  //  Current Location address
  const handleCL = () => {
    setPlaceholderAddress(`Current Location`)
    getGeoLocation()
    handleToggleCloseAll()
  }

  //  Current Location CName
  const handleCN = () => {
    setPlaceholderCName(`Current Location`)
    getGeoLocation()
    handleToggleCloseAll()
  }

  return (
    <MDBContainer tag="section">
      <Filter
        //  Drupal data
        locations={locations}
        featuredServices={props.featuredServices}
        //  state values
        searchtype={searchtype}
        radius={radius}
        checkedItems={checkedItems}
        placeholderAddress={placeholderAddress}
        placeholderCName={placeholderCName}
        //  handlers
        handleSearchtypeChange={handleSearchtypeChange}
        handleACupdate={handleACupdate}
        handleRadiusChange={handleRadiusChange}
        handleCentersNames={handleCentersNames}
        handleCheckboxesChange={handleCheckboxesChange}
        handleToggleOpen={handleToggleOpen}
        handleToggleCloseAll={handleToggleCloseAll}
        handleCL={handleCL}
        handleCN={handleCN}
      />
      <Views
        //  Drupal data
        locations={locations}
        //  state values
        startPosition={startPosition}
        positionWindow={positionWindow}
        radius={radius}
        stateCheck={stateCheck}
        //  handlers
        searchtype={searchtype}
        handleRadiusChange={handleRadiusChange}
        handleToggleOpen={handleToggleOpen}
        handleToggleCloseAll={handleToggleCloseAll}
        //  starsdata
        allPracticemaxRatings={props.allPracticemaxRatings}
        locationGroup={props.allNodeCenter}
        overridedistancesort={props.overridedistancesort}
      />
    </MDBContainer>
  )
}

export default Content
